module.exports = __webpack_public_path__ + "assets/img/icon1 (6).e6548fb1.png";